/**
 * @generated SignedSource<<71a4baefc141277ffa3823930965d96c>>
 * @relayHash 090a309bae12fcddd73edaf12962aaa3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID db1e2dd71d5da02d4d53f36625768a7dc322cd38beb182692d3f32ad6195812c

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluenceTrackType = "BRIEFING" | "NARRATION" | "%future added value";
export type ConfluenceTrackInput = {
  mainSource: string;
  supportingSources?: ReadonlyArray<string> | null | undefined;
  trackType: ConfluenceTrackType;
};
export type useContextMenuActionsRemoveTrackMutation$variables = {
  cloudId: string;
  input: ConfluenceTrackInput;
};
export type useContextMenuActionsRemoveTrackMutation$data = {
  readonly confluence_removeTrack: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useContextMenuActionsRemoveTrackMutation = {
  response: useContextMenuActionsRemoveTrackMutation$data;
  variables: useContextMenuActionsRemoveTrackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfluenceRemoveTrackPayload",
    "kind": "LinkedField",
    "name": "confluence_removeTrack",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "ConfluenceRemoveTrackPayloadError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          },
          {
            "concreteType": "ConfluenceRemoveTrackPayloadErrorExtension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "statusCode"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useContextMenuActionsRemoveTrackMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContextMenuActionsRemoveTrackMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "db1e2dd71d5da02d4d53f36625768a7dc322cd38beb182692d3f32ad6195812c",
    "metadata": {},
    "name": "useContextMenuActionsRemoveTrackMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a82da56f002288d2c61caae485db7176";

export default node;
